import { logs, SeverityNumber } from '@opentelemetry/api-logs';

const otelLogger = logs.getLogger('builder-home');

export interface LogContext {
  userId?: string;
  requestId?: string;
  feature?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export const logger = {
  info: (message: string, context?: LogContext) => {
    otelLogger.emit({
      severityNumber: SeverityNumber.INFO,
      severityText: 'INFO',
      body: message,
      attributes: context,
    });
    console.info(message, context);
  },

  warn: (message: string, context?: LogContext) => {
    otelLogger.emit({
      severityNumber: SeverityNumber.WARN,
      severityText: 'WARN',
      body: message,
      attributes: context,
    });

    console.warn(message, context);
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: (message: string, error?: any, context?: LogContext) => {
    otelLogger.emit({
      severityNumber: SeverityNumber.ERROR,
      severityText: 'ERROR',
      body: message,
      attributes: {
        ...context,
        error: error instanceof Error ? error.stack : error ? String(error) : undefined,
      },
    });

    console.error(message, error, context);
  },
};
